import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins.js"; // import {errorCode} from '@/config/errorCode'

import addRole from "./roleManCom/addRole";
import { getUserInfo } from "@/api/user";
import { addgroup, grouplist, delgroup, module_update, group_update, getgrouplist, groupPermission_config, getgroup_permission, default_role, getUserlist, addUserlist, openOroffUser, delUser, editUser } from "@/api/auth";
import addRoleEdit from "./roleManCom/addRoleEdit";
export default {
  name: "interfaceManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      group_name: null,
      dingji: localStorage.getItem('is_dingji'),
      headBtnList1: [{
        method: this.add,
        type: "primary",
        icon: "ios-add",
        name: this.$t('新增'),
        key: "addgroup"
      }],
      topButtonList: [{
        name: this.$t("query"),
        type: "primary",
        icon: "ios-search",
        method: this.okSearch
      }, {
        name: this.$t("reset"),
        type: "error",
        icon: "ios-refresh",
        method: this.resetSearch
      }],
      searchReq: {
        mods: []
      },
      tableData: [],
      columnsData: [{
        title: this.$t('用户账号'),
        key: "admin_name",
        align: "center"
      }, {
        title: this.$t('用户名称'),
        key: "name",
        align: "center"
      }, {
        title: this.$t('角色'),
        key: "group_names_str",
        align: "center"
      }, {
        title: this.$t('创建时间'),
        key: "addtime",
        align: "center"
      }, {
        title: this.$t('状态'),
        key: "status",
        align: "center",
        render: function render(h, _ref) {
          var row = _ref.row;
          var result = "";
          var color = "";

          if (row.status === 1) {
            result = _this2.$t("启用");
          } else {
            result = _this2.$t("禁用");
          }

          return h("span", result);
        }
      }, {
        title: this.$t('操作'),
        key: "explain",
        align: "center",
        width: 240,
        render: function render(h, _ref2) {
          var row = _ref2.row;
          var arr = [];
          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: "3px",
              color: "#2d8cf0"
            },
            props: {
              size: "small",
              type: "text"
            },
            on: {
              click: function click() {
                _this2.roleEdit(row);
              }
            }
          }, row.status == 1 ? _this2.$t('禁用') : _this2.$t('启用')));
          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: "3px",
              color: "#2d8cf0"
            },
            props: {
              size: "small",
              type: "text"
            },
            on: {
              click: function click() {
                _this2.edit(row);
              }
            }
          }, _this2.$t('编辑')));
          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: "3px",
              color: "#2d8cf0"
            },
            props: {
              size: "small",
              type: "text"
            },
            on: {
              click: function click() {
                _this2.delModule(row);
              }
            }
          }, _this2.$t('删除')));
          return h("div", arr);
        }
      }],
      tableLoading: false,
      tabletotallen: 0,
      border: true,
      stripe: true,
      moduleShow: false,
      addBase: {
        name: "",
        code: "",
        state: "",
        explain: ""
      },
      reqBase: {
        page: 1
      },
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      modalTitle: true,
      ruleValidate: {
        name: [{
          required: true,
          message: "请输入模块名",
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: "请输入模块代码",
          trigger: "change"
        }],
        explain: [{
          required: true,
          message: "请输入说明",
          trigger: "blur"
        }],
        state: [{
          required: true,
          message: "请选择状态",
          trigger: "change"
        }]
      }
    };
  },
  components: {},
  computed: {
    modelList: function modelList() {
      return this.$store.state.authCenter.ModuleData;
    }
  },
  methods: {
    init: function init() {
      this.getPageSizeToStorage();
      this.getData();
    },

    /**
     * 权限配置
     * */
    roleEdit: function roleEdit(row) {
      // openOroffUser()
      var vm = this;
      var config = {
        loading: true,
        title: this.$t('提示'),
        width: 400,
        content: this.$t('确定操作') + "<span style=\"color: #f60;\">".concat(row.name, "</span>\uFF1F"),
        onOk: function onOk() {
          var _this = this;

          var params = row.user_code,
              callbak = function callbak(req) {
            if (req.result === 0) {
              vm.$Message.success(vm.$t('操作成功！'));
              vm.$Modal.remove();
              vm.init();
            } else {
              _this.buttonLoading = false;
              vm.$Message.error(req.errorMsg);
            }
          }; //删除接口


          openOroffUser({
            user_code: row.user_code
          }).then(function (res) {
            callbak(res);
          });
        }
      };
      this.$Modal.confirm(config);
    },

    /**
     * 初始化数据
     */
    getData: function getData() {
      var _this3 = this;

      this.tableLoading = true;
      var vm = this; //;

      var callbak = function callbak(res) {
        _this3.tableLoading = false;
        vm.tableData = [];

        if (res.result === 0) {
          console.log("我的角色管理数据", res.body.list);
          vm.tableData = res.body.list || [];
          vm.tabletotallen = res.body.total;
        } else {
          vm.tableData = [];

          _this3.$Message.error(res.errorMsg);
        }
      };

      getUserlist(this.reqBase).then(function (res) {
        callbak(res);
      });
    },

    /**
     * 重置搜索框
     */
    resetSearch: function resetSearch() {
      this.group_name = null;
      this.okSearch();
    },
    okSearch: function okSearch() {
      Object.assign(this.reqBase, this.searchReq); //重置当前页为1

      this.reqBase.page = 1;
      this.reqBase.group_name = this.group_name;
      this.$refs.contentBaseRef.initcurrentPage();
      this.init();
    },

    /**
     * 翻页
     */
    pageonChange: function pageonChange(index) {
      this.addBase.page = index;
      this.getData();
    },

    /**
     * 筛选
     */
    showSearchParel: function showSearchParel() {
      this.$refs.search.expandPanel();
    },

    /**
     * 控制模态框显示隐藏
     * type 显示隐藏
     * handle true新增 false编辑
     * row 本条数据
     */
    add: function add() {
      var _this4 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var handle = arguments.length > 1 ? arguments[1] : undefined;
      var row = arguments.length > 2 ? arguments[2] : undefined;
      var vm = this;
      var config = {
        loading: true,
        width: 600,
        okText: this.$t('确定'),
        cancelText: this.$t('取消'),
        render: function render(h) {
          return h("div", [h("h3", _this4.$t('新增用户')), h(addRole, {
            ref: "addRole",
            props: {
              edit: false,
              _vm: vm,
              type: 'add'
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addRole;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              addUserlist(_objectSpread({}, formModel, {
                menu_codes: []
              })).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(vm.$t('添加成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    edit: function edit(row) {
      var _this5 = this;

      console.log('rowrowrow', row);
      var vm = this;
      var config = {
        loading: true,
        width: 600,
        okText: this.$t('确定'),
        cancelText: this.$t('取消'),
        render: function render(h) {
          return h("div", [h("h3", _this5.$t('编辑用户')), h(addRole, {
            ref: "addRole",
            props: {
              edit: true,
              _vm: vm,
              setData: row,
              type: 'edit'
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addRole;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              editUser(_objectSpread({}, formModel, {
                menu_codes: [],
                group_codes: [formModel.group_codes],
                user_code: row.user_code
              })).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(vm.$t('修改成功！'));
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },

    /**
     * 编辑
     * modalTitle true新增  false编辑
     */
    editInit: function editInit(row) {
      this.addBase = {
        name: row.name,
        code: row.code,
        state: row.state,
        explain: row.explain
      };
    },
    //新增/编辑提交
    addModuleOk: function addModuleOk() {
      var _this6 = this;

      var _this = this;

      var title = _this.modalTitle ? this.$t('新增') : this.$t('编辑');

      var params = _this.addBase,
          callbak = function callbak(req) {
        if (req.status === 1) {
          _this6.$Message.success("".concat(title, ":").concat(req.msg));
        } else {
          _this6.$Message.error("".concat(title, ":").concat(req.msg));
        }
      };

      this.$refs.addmodal.validate(function (valid) {
        if (valid) {
          if (_this.modalTitle) {//新增接口
          } else {//编辑接口
            }
        } else {
          _this6.$Message.error("请检查必填项");
        }
      });
    },

    /**
     * 删除
     */
    delModule: function delModule(row) {
      var vm = this;
      var config = {
        loading: true,
        title: this.$t('删除'),
        width: 400,
        content: this.$t('删除') + "<span style=\"color: #f60;\">".concat(row.name, "</span>\uFF1F"),
        onOk: function onOk() {
          var _this = this;

          var params = {
            id: row.id
          },
              callbak = function callbak(req) {
            if (req.result === 0) {
              vm.$Message.success(vm.$t('删除成功！'));
              vm.$Modal.remove();
              vm.init();
            } else {
              _this.buttonLoading = false;
              vm.$Message.error(req.errorMsg);
            }
          }; //删除接口


          delUser({
            user_code: row.user_code
          }).then(function (res) {
            callbak(res);
          });
        }
      };
      this.$Modal.confirm(config);
    }
  },
  mounted: function mounted() {
    //获取相应权限
    this.getFunctionRole();
    console.log(this.functionRole);
    this.init();
  },
  created: function created() {}
};